import { Component, OnInit } from '@angular/core';
import { CrossoverService } from 'src/app/services/crossover.service';
import * as Highcharts from 'highcharts';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';

@Component({
  selector: 'app-ultimi-valori-m15',
  templateUrl: './ultimi-valori-m15.component.html',
  styleUrls: ['./ultimi-valori-m15.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HighchartsChartModule]
})
export class UltimiValoriM15Component implements OnInit {

  dati: any = []
  datiTable: any = []
  datiTotali: any = []
  datiCrossTimeframe: any = []
  headers = ['ora', 'eur', 'usd', 'gbp', 'jpy', 'aud', 'nzd', 'cad', 'chf']
  mercati = ['eur', 'usd', 'gbp', 'jpy', 'aud', 'cad', 'chf', 'nzd'];
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}
  chartOptions2: Highcharts.Options = {}
  chartOptions3: Highcharts.Options = {}
  chartOptions4: Highcharts.Options = {}
  vediChart: boolean = false;


  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  frmCambio: FormGroup = new FormGroup({
    vs1: new FormControl(),
    vs2: new FormControl()
  })
  oraUltimoValore: string = ''

  mkt1: any = ['eur', 'usd', 'gbp', 'aud', 'cad', 'chf', 'nzd']
  mkt2: any = ['usd', 'gbp', 'jpy', 'aud', 'cad', 'chf', 'nzd']
  loading: boolean = false

  listaMercati: any = []
  listaSegnaliCT2_m15: any = []

  constructor(private serv: CrossoverService) { }


  ngOnInit(): void  {
    this.serv.listM15().subscribe((data: any) => {
      if (data.res == 'ok') {
        this.datiTable = data.dati.slice(0, 10)
        this.dati = data.dati.sort((a: any, b: any) => (new Date(a.ora)).getTime() - (new Date(b.ora).getTime()))
        this.datiTotali = data.dati//.sort((a: any, b: any) => a.ora - b.ora)
        this.aggiornaGrafico(this.dati)
        this.serv.getMarkets().subscribe((data: any) => {
          this.listaMercati = data.data.filter((el: any) => {
            return el.tipo == 'Major' || el.tipo == 'Cross'
          })
          this.analisiSegnaliCT2_m15()
        })
      }
    })
    this.serv.crossTimeframe().subscribe((data: any) => {
      if (data.res == 'ok') {
        this.datiCrossTimeframe = data.data
      }
    })
  }

  analisiSegnaliCT2_m15() {
    this.listaSegnaliCT2_m15 = []
    this.listaMercati.forEach((el: any) => {
      let mkt1 = el.market.substring(0, 3).toLowerCase()
      let mkt2 = el.market.substring(3, 6).toLowerCase()
      let ct2 = this.datiTable[0][mkt1] - this.datiTable[0][mkt2]
      if (Math.abs(ct2) > 30) {
        this.listaSegnaliCT2_m15.push({ mkt: el.market, ct2: ct2 })
      }
    })
  }

  aggiorna() {
    this.loading = true
    this.serv.aggiornaCross().subscribe((data: any) => {
      if (data.res == 'ok') {
        this.serv.listM15().subscribe((data: any) => {
          console.log(data)
          this.loading = false
          if (data.res == 'ok') {
            this.datiTable = data.dati.slice(0, 10)
            this.dati = data.dati.sort((a: any, b: any) => (new Date(a.ora)).getTime() - (new Date(b.ora).getTime()))
            this.datiTotali = data.dati//.sort((a: any, b: any) => a.ora - b.ora)
            this.aggiornaGrafico(this.dati)
            this.analisiSegnaliCT2_m15()
          }
        })
      }
    })
  }

  aggiornaCrossTimeframe(m1: string, m2: string, numeroDato: number = 1000) {
    this.serv.valoriCambio(m1 + m2, this.datiCrossTimeframe[0].ora).subscribe((data: any) => {
      if (data.res == 'ok') {
        let s1 = this.datiCrossTimeframe.map((el: any) => [el.ora, parseFloat(el[m1 + '_' + 'm15']) - parseFloat(el[m2 + '_' + 'm15'])])
        let s2 = this.datiCrossTimeframe.map((el: any) => [el.ora, parseFloat(el[m1 + '_' + 'h1']) - parseFloat(el[m2 + '_' + 'h1'])])
        let s3 = this.datiCrossTimeframe.map((el: any) => [el.ora, parseFloat(el[m1 + '_' + 'h4']) - parseFloat(el[m2 + '_' + 'h4'])])
        let s4 = data.data.slice(-1000).map((el: any) => [el.ora, parseFloat(el.vclose)])
        let ser: Highcharts.SeriesOptionsType[] = [
          { name: 'm15', type: 'line', data: s1, color: 'orange', dashStyle: 'LongDash' },
          { name: 'h1', type: 'line', data: s2, dashStyle: 'LongDashDot', color: '#4A92B2' },
          { name: 'h4', type: 'line', data: s3, dashStyle: 'ShortDot', color: '#4AB28D' },
          { name: m1 + m2, type: 'line', data: s4, yAxis: 1, color: 'lightgreen' },
        ]
        this.chartOptions4 = {
          title: {
            text: 'CrossTimeFrame ' + m1.toUpperCase() + m2.toUpperCase()
          },
          chart: {
            zooming: {
              type: 'x'
            }
          },
          yAxis: [{
            plotLines: [{
              value: 0,
              width: 2,
              color: 'black',
              zIndex: 4
            }]
          },
          {
            title: { text: 'Cambio' },
            opposite: true
          },
          ],
          series: ser
        }
      }
    })
  }

  aggiornaGrafico(dati: any, numeroDato: number = 200) {
    let s1 = dati.map((el: any) => [el.ora, parseFloat(el.eur)])
    let s2 = dati.map((el: any) => [el.ora, parseFloat(el.usd)])
    let s3 = dati.map((el: any) => [el.ora, parseFloat(el.gbp)])
    let s4 = dati.map((el: any) => [el.ora, parseFloat(el.jpy)])
    let s5 = dati.map((el: any) => [el.ora, parseFloat(el.aud)])
    let s6 = dati.map((el: any) => [el.ora, parseFloat(el.nzd)])
    let s7 = dati.map((el: any) => [el.ora, parseFloat(el.cad)])
    let s8 = dati.map((el: any) => [el.ora, parseFloat(el.chf)])
    s1 = s1.splice(s1.length - numeroDato)
    s2 = s2.splice(s2.length - numeroDato)
    s3 = s3.splice(s3.length - numeroDato)
    s4 = s4.splice(s4.length - numeroDato)
    s5 = s5.splice(s5.length - numeroDato)
    s6 = s6.splice(s6.length - numeroDato)
    s7 = s7.splice(s7.length - numeroDato)
    s8 = s8.splice(s8.length - numeroDato)
    let ser: Highcharts.SeriesOptionsType[] = [
      { name: 'eur', type: 'line', data: s1 },
      { name: 'usd', type: 'line', data: s2 },
      { name: 'gbp', type: 'line', data: s3 },
      { name: 'jpy', type: 'line', data: s4 },
      { name: 'aud', type: 'line', data: s5 },
      { name: 'nzd', type: 'line', data: s6 },
      { name: 'cad', type: 'line', data: s7 },
      { name: 'chf', type: 'line', data: s8 },
    ]
    this.chartOptions = {
      title: {
        text: 'CrossOver M15'
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      yAxis: [{
        plotLines: [{
          value: 0,
          width: 2,
          color: 'black',
          zIndex: 4
        }]
      }
      ],
      series: ser
    }
  }
  valoriGrafico(event: any) {
    console.log(event.target.value)
    this.aggiornaGrafico(this.datiTotali, event.target.value)
  }

  applicaCambio(mkt: string) {
    this.vediChart = true
    let mkt1 = mkt.substring(0, 3).toLowerCase()
    let mkt2 = mkt.substring(3, 6).toLowerCase()
    this.aggiornaCrossTimeframe(mkt1, mkt2)
    this.serv.valoriCambio(mkt1 + mkt2, this.datiTotali[0].ora).subscribe((data: any) => {
      if (data.res == 'ok') {
        let s1 = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt1])])
        let s2 = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt2])])
        let s3 = data.data.map((el: any) => [el.ora, parseFloat(el.vclose)])
        let s1a = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt1]) - parseFloat(el[mkt2])])
        let ser: Highcharts.SeriesOptionsType[] = [
          { name: mkt1, type: 'line', data: s1, dashStyle: 'ShortDot' },
          { name: mkt2, type: 'line', data: s2, dashStyle: 'ShortDot' },
          { name: 'CrossTrend', type: 'line', data: s1a, dashStyle: 'LongDash', color: 'orange' },
          { name: mkt1 + mkt2, type: 'line', data: s3, yAxis: 4, color: 'lightgreen' },
        ]
        this.chartOptions2 = {
          title: {
            text: 'CrossOver M15 ' + mkt1 + mkt2
          },
          chart: {
            zooming: {
              type: 'x'
            }
          },
          yAxis: [
            {
              plotLines: [{
                value: 0,
                width: 2,
                color: 'black'
              }]
            },
            {
              title: { text: mkt1 }
            },
            {
              title: { text: mkt2 }
            },
            {
              title: { text: 'CrossTrend' },
            },
            {
              title: { text: 'Cambio' },
              opposite: true
            },
          ],
          series: ser
        }

        let ser2: Highcharts.SeriesOptionsType[] = [
          { name: 'CrossTrend', type: 'line', data: s1a, dashStyle: 'LongDash', color: 'orange' },
          { name: mkt1 + mkt2, type: 'line', data: s3, yAxis: 2, color: 'lightgreen' },
        ]
        this.chartOptions3 = {
          title: {
            text: 'CrossOver M15 ' + mkt1 + mkt2
          },
          chart: {
            zooming: {
              type: 'x'
            }
          },
          xAxis: {
            //type: 'datetime'
          },
          yAxis: [{
            plotLines: [{
              value: 0,
              width: 2,
              color: 'gray'
            }]
          },
          {
            title: { text: mkt1 + mkt2 }
          },
          {
            title: { text: 'Cambio' },
            opposite: true
          }
          ],
          series: ser2
        }
      }
    })
  }

}
